import { http } from "@/http/axios.js";
import axios from "axios";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { showScreenLoading, hideScreenLoading } from "@/http/loading.js";
import { Message } from "element-ui";
import { dateFormat } from "@/utils/index.js";
// 列表
export function getListAPI(params) {
  return http({
    url: "/admin/finance/bill/page",
    method: "get",
    params,
  });
}
// 添加流水
export function addFinanceBillAPI(data) {
  return http({
    url: "/admin/finance/bill/add",
    method: "post",
    data,
  });
}

// 修改账单手续费
export function editCommision(data) {
  return http({
    url: "/admin/finance/bill/amount/edit",
    method: "post",
    data,
  });
}

// 导出
export function exportAPI(data) {
  showScreenLoading();
  axios({
    method: "post",
    url: "/api/admin/finance/bill/export",
    responseType: "blob",
    data,
    headers: {
      Authorization: getToken() || "",
    },
  })
    .then(async (res) => {
      hideScreenLoading();
      let data = res.data;
      let url = window.URL.createObjectURL(new Blob([data]));
      let a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      let filename = `OK租机财务明细${dateFormat()}.xlsx`;
      a.setAttribute("download", decodeURIComponent(filename));
      document.body.appendChild(a);
      a.click(); //执行下载
      window.URL.revokeObjectURL(a.href); //释放url
      document.body.removeChild(a); //释放标签
    })
    .catch((error) => {
      hideScreenLoading();
      console.log(error);
    });
}
